import { render, staticRenderFns } from "./ItemAdminGeneralDepartment.vue?vue&type=template&id=713426e8&scoped=true&"
import script from "./ItemAdminGeneralDepartment.vue?vue&type=script&lang=js&"
export * from "./ItemAdminGeneralDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdminGeneralDepartment.vue?vue&type=style&index=0&id=713426e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713426e8",
  null
  
)

export default component.exports